import './componenteTablaLight.css'
export default function EstadoComponenteTablaLight({ stro, estados }) {
    const estadoColorMap = {
        101: '#BD0000',
        102: '#F6D776',
        103: '#DDAF6E',
        104: '#D99536',
        105: '#DC5E50',
        106: '#DB5C82',
        107: '#F58F00',
        108: '#3A54A1',
        109: '#444683',
        110: '#2B3A69',
        111: '#2E3447',
        112: '#9ED6B9',
        113: '#8AC478',
        114: '#79E293',
        115: '#5155ab',
        200: '#CCC9D9',
        201: '#42C3BA',
        203: 'red',
        204: 'black',
        301: '#48CFCB',
        302: '#425CEB',
        303: '#C96868',
        304: '#FADFA1',
        305: '#7DB593',
        306: '#ACCDE1',
        307: '#3A54A1',
        308: '#F58F00',
        309: '#545454',
        310: '#808D7C',
        311: '#41E121',
        400: '#7826C9',
    };
    return (
        <th className='textoBodyTablaLight'>
            <div className='d-flex flex-column gap-1'>
                {stro.estados.map((estado, i) => (
                    <div key={i} className="d-flex align-items-center gap-2">
                        <div
                            style={{
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                backgroundColor: estadoColorMap[estado] || '#CCC9D9'
                            }}
                        />
                        <span>
                            {estados.find((e) => e.id === Number(estado))?.abreviacion}
                        </span>
                    </div>
                ))}
            </div>
        </th>

    );
}
